<template>
  <div>
    <navHeader></navHeader>
    <div class="container-lg mt-5">
      <div class="row border-bottom">
        <div class="col-lg-8 col-md-12 col-12">
          <div class="p-3">
            <h2 class="main-title">Morning Primer Archive</h2>
            <label
              >
              Your start of the day buddy. Morning Primer lets you know the latest economic and corporate developments before the opening bell to help you with your trades. It also gives our market expectation and stock recommendation for the day. Best read with a cup of coffee.</label
            >
          </div>
        </div>
        <div class="col-lg-4 col-md-12 col-12">
          <div class="p-3 d-flex align-items-center justify-content-lg-end mt-lg-5">
             <date-picker
              class="date-picker"
              v-model="date"
              range
              :default-value="date"
              @clear="ChangeDate"
              :class="{ error: $v.date.$error }"
            ></date-picker>
            <button class="btn glob-btn" @click="Search(date)">Search</button>
          </div>
        </div>
      </div>
     
       <ul style="list-style-type:circle;margin-top:2em;"  v-if="loading == false">
            <li v-for="(item, index) in generateList(MorningPrimerArchive)[
            currentPage - 1
          ]"
          :key="index">
         <a href="javascript:void(0)" @click="ViewReport(item)"  v-b-modal.morningPrimer
          >  {{ FormatDate(item.date) }} </a></li>
          </ul>
      <b-modal
        id="morningPrimer"
        size="xl"
        title="Extra Large Modal"
        v-model="marketPrimerModalShow"
      >
        <div class="text-right">
          <i
            class="bi bi-x pointer m-4"
            style="font-size: 2em"
            @click="marketPrimerModalShow = !marketPrimerModalShow"
          ></i>
        </div>
        <MorningPrimer />
        <img src="../../../../assets/Images/wave.svg"  class="svg-footer">
      </b-modal>
      <div class="d-flex justify-content-center mt-5">
          <b-pagination
            size="lg"
            v-model="currentPage"
            :total-rows="MorningPrimerArchive.length"
            :per-page="perPage"
            v-if="MorningPrimerArchive.length  > perPage"
          ></b-pagination>
        </div>
         <Noresult v-if="MorningPrimerArchive.length == 0 &&  loading== false"  />
      <Searching v-if="loading == true" />
    </div>
  </div>
</template>

<script>
import navHeader from "../../NavHeader.vue";
import { mapState } from "vuex";
import moment from "moment";
import MorningPrimer from "../../FullReports/MorningPrimerFullReport.vue";
import { required } from "vuelidate/lib/validators";
import Noresult from "../../NoResult";
import Searching from "../../Searching.vue";
export default {
  components: {
    MorningPrimer,
    navHeader,
    Noresult,
    Searching,
  },
  data() {
    return {
      perPage: 30,
      currentPage: 1,
      marketPrimerModalShow: false,
       date: [
        new Date(moment().startOf("year").format("MM/DD/YYYY")),
        new Date(moment().format("MM/DD/YYYY")),
      ],
      dateFrom: "",
      dateTo: "",
      loading:false,
    };
  },
     validations: {
    date: { required },
  },
  computed: {
    ...mapState({
      MorningPrimerArchive: (state) => state.philstocksResearch.morningPrimerArchive,
    }),
  },
  methods: {
      GoogleAnalytics() {
      this.$gtag.event("MorningPrimerArchive", { method: "Google" });
    },
     ChangeDate() {
      this.dateFrom = "";
      this.dateTo = "";
      this.$v.date.$reset();
      this.date=[];
    },
    ViewReport(data) {
      this.$store.dispatch("philstocksResearch/SET_FullReport", data);
    },
    FormatDate(date) {
      var result = "";
      if (date == "0001-01-01T00:00:00") {
        result = "-------";
      } else {
        result = moment(date).format("MMMM DD, YYYY");
      }
      return result;
    },

     async Search(data) {
      this.dateFrom = moment(data[0]).format("L");
      this.dateTo = moment(data[1]).format("L");
      var payload = {
        DateFrom: this.dateFrom,
        DateTo: this.dateTo,
      };
      this.$v.date.$touch();
      if (this.$v.date.$invalid) {
        this.dateFrom = "";
        this.dateTo = "";
      } else {
        var _this = this;
        this.loading = true;
        let searchArchive = await this.$store
          .dispatch("philstocksResearch/GetMorningPrimerArchive", payload)
          .catch(function (error) {
             console.log(error);
            _this.loading = false;
          });

        if (searchArchive) {
          _this.loading = true;
        }
        
        _this.loading = false;
      }
    },

    generateList(data) {
      var list = 30;
      var result = data.reduce((resultArray, item, index) => {
        const listIndex = Math.floor(index / list);
        if (!resultArray[listIndex]) {
          resultArray[listIndex] = []; // start a new list
        }
        resultArray[listIndex].push(item);
        return resultArray;
      }, []);
      return result;
    },
async GetMorningPrimerArchive() {
        var _this = this;
        this.loading = true;
      var payload = {
        DateFrom: moment().startOf("year").format("MM/DD/YYYY"),
        DateTo: moment().format("MM/DD/YYYY"),
      };
     let morningPrimer =  await this.$store
        .dispatch("philstocksResearch/GetMorningPrimerArchive", payload)
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
      if (morningPrimer) {
       _this.loading = true;
      }
        _this.loading = false;
    },
    
  },

  async mounted() {
    this.GetMorningPrimerArchive();
  },
};
</script>
<style></style>
